import React, { useState, useRef, useEffect, useCallback } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import API from "../../services/api";
import { t } from "@lingui/macro";

const TicketScanner = () => {
  const [isScanning, setIsScanning] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const [showMessage, setShowMessage] = useState(false); 
  const scannerRef = useRef(null);

  const successSound = new Audio("/sounds/success.wav");
  const errorSound = new Audio("/sounds/error.ogg");

  const startScanner = useCallback(() => {
    setMessage(null);
    setMessageType(null);
    setShowMessage(false); 
    if (!scannerRef.current) {
      scannerRef.current = new Html5QrcodeScanner("scanner", {
        fps: 1, 
        qrbox: { width: 250, height: 250 },
      });

      scannerRef.current.render(handleScanSuccess, handleScanError);
    }
  }, []);

  const restartScanner = () => {
    setShowMessage(false); 
    setIsScanning(true); 
  };

  useEffect(() => {
    if (isScanning) {
      startScanner();
    } else {
      stopScanner();
    }
    return () => stopScanner();
  }, [isScanning, startScanner]);

  const stopScanner = () => {
    if (scannerRef.current) {
      scannerRef.current.clear();
      scannerRef.current = null;
    }
  };

  const handleScanSuccess = async (qrHash) => {
    stopScanner();
    try {
      const response = await API.post("/api/tickets/verify", { qrHash });
      const { message } = response.data;

      const messageType =
        message === "Ticket verified successfully" ? "success" : "error";
      setMessageType(messageType);

      if (messageType === "success") {
        successSound.play();
        setMessage(message);
        setShowMessage(true);
        setIsScanning(false);
        setTimeout(() => {
          setShowMessage(false);
          setIsScanning(true); 
        }, 3000);
      }

      if (messageType === "error") {
        errorSound.play();
        setMessage(message);
        setShowMessage(true);
        setIsScanning(false);
      }

    } catch (error) {
      const errorMessage = t`Verification failed`;
      setMessageType("error");
      setMessage(errorMessage);
      errorSound.play();
      setShowMessage(true); 
      setIsScanning(false);
    }
  };

  const handleScanError = (err) => {
    console.error("Scan error:", err);
  };

  return (
    <div className="flex flex-col items-center gap-4 p-4 w-full max-w-sm mx-auto">
      <button
        onClick={() => setIsScanning((prev) => !prev)}
        className="add-new-btn"
      >
        {isScanning ? t`Stop Scan` : t`Start Scan`}
      </button>

      <div id="scanner-container" className="relative w-full max-w-md">
        {isScanning ? (
          <div id="scanner" className="w-full max-w-md"></div>
        ) : (
          showMessage && message && (
            <div
              className={`message-container ${
                messageType === "success" ? "success" : "error"
              }`}
            >
              <p>{message}</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TicketScanner;
